import { render, staticRenderFns } from "./CadastrarCaixa2.vue?vue&type=template&id=31dc9621&scoped=true&"
import script from "./CadastrarCaixa2.vue?vue&type=script&lang=js&"
export * from "./CadastrarCaixa2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dc9621",
  null
  
)

export default component.exports